export const defaultPrimaryStyles = {
  default: {
    backgroundColor:
      "var(--theme-website-primary-button-default-background-color)",
    borderColor: "var(--theme-website-primary-button-default-border-color)",
    borderRadius: {
      border_left_top_radius:
        "var(--theme-website-primary-button-default-border-left-top-radius)",
      border_left_bottom_radius:
        "var(--theme-website-primary-button-default-border-left-bottom-radius)",
      border_right_top_radius:
        "var(--theme-website-primary-button-default-border-right-top-radius)",
      border_right_bottom_radius:
        "var(--theme-website-primary-button-default-border-right-bottom-radius)",
    },
    borderWidth: "var(--theme-website-primary-button-default-border-width)",
    color: "var(--theme-website-primary-button-default-text-color)",
    fontSize: "var(--theme-website-primary-button-default-font-size)",
    fontStyle: "normal",
    fontWeight: "var(--theme-website-primary-button-default-font-weight)",
    lineHeight: "var(--theme-website-primary-button-default-line-height)",
    textAlign: "left",
    textDecoration: "none",
    textTransform: "none",
  },
  hover: {
    backgroundColor:
      "var(--theme-website-primary-button-hover-background-color)",
    borderColor: "var(--theme-website-primary-button-hover-border-color)",
    borderRadius: {
      border_left_top_radius:
        "var(--theme-website-primary-button-hover-border-left-top-radius)",
      border_left_bottom_radius:
        "var(--theme-website-primary-button-hover-border-left-bottom-radius)",
      border_right_top_radius:
        "var(--theme-website-primary-button-hover-border-right-top-radius)",
      border_right_bottom_radius:
        "var(--theme-website-primary-button-hover-border-right-bottom-radius)",
    },
    borderWidth: "var(--theme-website-primary-button-hover-border-width)",
    color: "var(--theme-website-primary-button-hover-text-color)",
    fontSize: "var(--theme-website-primary-button-hover-font-size)",
    fontStyle: "normal",
    fontWeight: "var(--theme-website-primary-button-hover-font-weight)",
    lineHeight: "var(--theme-website-primary-button-hover-line-height)",
    textAlign: "left",
    textDecoration: "none",
    textTransform: "none",
  },
  sizing: {
    width: "100px",
    height: "40px",
    minWidth: "100px",
    minHeight: "40px",
    maxWidth: "100px",
    maxHeight: "40px",
  },
  padding: {
    paddingTop: "var(--theme-website-primary-button-padding-top)",
    paddingBottom: "var(--theme-website-primary-button-padding-bottom)",
    paddingLeft: "var(--theme-website-primary-button-padding-left)",
    paddingRight: "var(--theme-website-primary-button-padding-right)",
  },
  margin: {
    marginTop: "0",
    marginBottom: "0",
    marginLeft: "0",
    marginRight: "0",
  },
} as const;
